import { Logo } from '@/components/logo'
import { Auth } from '@/services/auth-service'
import { attr, html, When } from '@tempots/dom'
import { Anchor, HTMLTitle } from '@tempots/ui'

/**
 * Catch-all for unknown routes: a way back, not a dead end.
 */
export function NotFoundPage() {
  return html.div(
    HTMLTitle('Page Not Found - ResumeHeaders'),
    attr.class(
      'min-h-screen flex flex-col items-center justify-center gap-6 px-4 text-center bg-gray-50'
    ),
    Anchor({ href: '/' }, Logo({ size: 'main' })),
    html.div(
      html.h1(attr.class('text-2xl font-bold text-gray-800'), 'Page not found'),
      html.p(
        attr.class('text-gray-600 mt-2 max-w-md'),
        'The page you were looking for doesn’t exist — the link may be old, or the address mistyped.'
      )
    ),
    html.div(
      attr.class('flex flex-wrap items-center justify-center gap-3'),
      When(
        Auth.isSignedIn,
        () =>
          Anchor(
            { href: '/start' },
            attr.class(
              'inline-block px-4 py-2 rounded-md bg-teal-700 text-white text-sm font-semibold hover:bg-teal-800'
            ),
            'Go to your workspace'
          ),
        () =>
          Anchor(
            { href: '/signin' },
            attr.class(
              'inline-block px-4 py-2 rounded-md bg-teal-700 text-white text-sm font-semibold hover:bg-teal-800'
            ),
            'Sign in'
          )
      ),
      Anchor(
        { href: '/' },
        attr.class(
          'inline-block px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-100'
        ),
        'Go to the homepage'
      )
    ),
    html.p(
      attr.class('text-xs text-gray-400'),
      'Still stuck? ',
      Anchor(
        { href: '/contact' },
        attr.class('underline hover:text-gray-600'),
        'Contact us'
      ),
      '.'
    )
  )
}
